import { useAsyncEffect, useNotifications, useRouter } from "@relode/core";
import qs from "qs";

import { ClientPublicCandidateState } from "../clientPublicCandidateState";
import {
    CombinedClientPublicCandidateActions,
} from "../combinedClientPublicCandidateActions";

export const useClientPublicCandidateHandlers = (
    state: ClientPublicCandidateState,
    actions: CombinedClientPublicCandidateActions
) => {
    const { actions: notifications } = useNotifications();
    const {
        location: { search },
    } = useRouter();

    useAsyncEffect(async () => {
        const queryString = qs.parse(search, { ignoreQueryPrefix: true });
        if (
            queryString &&
            Object.keys(queryString).length > 0 &&
            queryString.token
        ) {
            await actions.loadCandidate(queryString.token as string);
        } else {
            notifications.showArea(
                "info",
                "Currently you can view a specific candidate only by clicking the link from your email.",
                "loadCandidate",
                {
                    canClose: false,
                }
            );
        }
    }, []);
};
